const nameData = "tipoiva"; // Define la entidad dinámica
const nameDataSingular = "tipoiva"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData) => {
  try {
    const data = await getEntityPanelData();
    if (data) {
      return {
        dataEntity: data|| [], 
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
